<div class="ui-button a-order" (click)="switchStatus($event)" (blur)="onblur($event)">
    <ng-container *ngTemplateOutlet="contentTemplate!=null?contentTemplate:default;context:{$implicit:desc}">

    </ng-container>

</div>

<ng-template #default let-isdesc>
    <span class="container">
        <span class="left"><i class="fa " [ngClass]="isdesc?'fa-long-arrow-up':'fa-long-arrow-down'"
                aria-hidden="true"></i></span>
        <span class="right">
            <div>A</div>
            <div>Z</div>
        </span>
    </span>
</ng-template>